import { render, staticRenderFns } from "./ActivityScheduleRegistration.vue?vue&type=template&id=016f5d7d&scoped=true&"
import script from "./ActivityScheduleRegistration.vue?vue&type=script&lang=js&"
export * from "./ActivityScheduleRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ActivityScheduleRegistration.vue?vue&type=style&index=0&id=016f5d7d&lang=scss&scoped=true&"
import style1 from "./ActivityScheduleRegistration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f5d7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VDialog,VForm,VRow,VSelect,VTextarea})
